import PAGE from "modules/router/page";
import { APSAPI } from "modules/uri";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { MainView } from "../../modules/mainview";
import { FirstContent } from "./first-content";
import { SecondContent } from "./second-content";
import Modal from "../../modules/UserModal";
import { commonErrorMessage } from "modules/constant";

export function HomePage(props: RouteComponentProps) {
  const [error, setError] = React.useState<string>("");

  const verifyIdCardBO = async (secuityNo: string, policyNum: string, siteKey: string) => {
    try {
      const formDataJson = {
        policyNum: policyNum,
        securityNo: secuityNo,
        captchaKey: siteKey
      };

      const resp = await fetch(`${APSAPI}/check-customer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ formDataJson: formDataJson }),
      });

      const respData = await resp.json();
      return respData;
    } catch (err) {
      return null;
    }
  };

  const goToInvoicesList = async (secuityNo: string, policyNum: string, captchaToken: string) => {
    if (secuityNo) {
      const verify = await verifyIdCardBO(secuityNo, policyNum, captchaToken);
      if (verify) {
        if (verify.status === "SUCCESS") {
          localStorage.setItem("token", verify.formDataJson?.token || "");
          props.history.push(`${PAGE.APS_LIST}`)
          return
        }
        if (verify.oErrorResult) {
          setError(verify.oErrorResult?.errorDescription || commonErrorMessage);
          return;
        }
      }
    }
    setError(commonErrorMessage);
  };

  const handleCloseModal = () => {
    setError("");
  };

  React.useEffect(() => {
    localStorage.removeItem("token");
  }, []);

  return (
    <MainView>
      <FirstContent onSubmit={(secuityNo, policyNum, captchaToken) => goToInvoicesList(secuityNo, policyNum, captchaToken)} />
      <SecondContent />
      <Modal
        title="Thông báo"
        content={error}
        titleSubmit="Thoát"
        open={error ? true : false}
        handleSubmit={handleCloseModal}
      />
    </MainView>
  );
}